"use client";

import Link from "next/link";
import { useTranslation } from "@/lib/i18n";
import { useAccountStore } from "@/modules/account/store";
import { Button } from "@/components/ui/button";

export default function ChatIndexPage() {
  const t = useTranslation();
  const accounts = useAccountStore((s) => s.accounts);
  const pendingInvitations = useAccountStore((s) => s.pendingInvitations);

  if (accounts.length === 0) {
    return (
      <div className="flex flex-1 items-center justify-center px-6">
        <div className="w-full max-w-md rounded-2xl border border-m-divider bg-m-surface px-6 py-8 text-center shadow-sm">
          <h1 className="text-xl font-semibold text-m-text">
            {t("empty_state.no_accounts_title")}
          </h1>
          <p className="mt-3 text-sm leading-6 text-m-text-secondary">
            {t("empty_state.no_accounts_description")}
          </p>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
            <Button asChild>
              <Link href="/create-account">{t("empty_state.create_account")}</Link>
            </Button>
            <Button asChild variant="outline">
              <Link href="/invitations">
                {pendingInvitations.length > 0
                  ? t("empty_state.open_invitations")
                  : t("empty_state.ask_for_invite")}
              </Link>
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-1 items-center justify-center text-m-text-hint">
      {t("conversations.select")}
    </div>
  );
}
